var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_522_11102)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_522_11102)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.1998 40H11.7998C9.14879 40 6.99976 37.851 6.99976 35.2V4.8C6.99976 2.14903 9.14879 0 11.7998 0H20.1526C21.598 0 22.9665 0.651346 23.8779 1.77315L31.9251 11.6774C32.6203 12.533 32.9998 13.6018 32.9998 14.7042V35.2C32.9998 37.851 30.8507 40 28.1998 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1998 39.4H11.7998C9.48016 39.4 7.59976 37.5196 7.59976 35.2V4.8C7.59976 2.4804 9.48016 0.6 11.7998 0.6H20.1526C21.4173 0.6 22.6147 1.16993 23.4123 2.15151L31.4594 12.0557C32.0677 12.8044 32.3998 13.7396 32.3998 14.7042V35.2C32.3998 37.5196 30.5194 39.4 28.1998 39.4Z",
    stroke: "#CDD0D5",
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M26 1V7.8C26 9.56731 27.4327 11 29.2 11H36",
    stroke: "#CDD0D5",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_522_11102)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-1_522_11102",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 25C0 23.3431 1.34315 22 3 22H29C30.6569 22 32 23.3431 32 25V33C32 34.6569 30.6569 36 29 36H3C1.34315 36 0 34.6569 0 33V25Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 25C0 23.3431 1.34315 22 3 22H29C30.6569 22 32 23.3431 32 25V33C32 34.6569 30.6569 36 29 36H3C1.34315 36 0 34.6569 0 33V25Z",
    fill: "#375DFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.8 25C-0.8 22.9013 0.901318 21.2 3 21.2H29C31.0987 21.2 32.8 22.9013 32.8 25H31.2C31.2 23.785 30.215 22.8 29 22.8H3C1.78497 22.8 0.8 23.785 0.8 25H-0.8ZM32 36H0H32ZM3 36C0.901318 36 -0.8 34.2987 -0.8 32.2V25C-0.8 22.9013 0.901318 21.2 3 21.2V22.8C1.78497 22.8 0.8 23.785 0.8 25V33C0.8 34.6569 1.78497 36 3 36ZM29 21.2C31.0987 21.2 32.8 22.9013 32.8 25V32.2C32.8 34.2987 31.0987 36 29 36C30.215 36 31.2 34.6569 31.2 33V25C31.2 23.785 30.215 22.8 29 22.8V21.2Z",
    fill: "black",
    fillOpacity: 0.08,
    mask: "url(#path-4-inside-1_522_11102)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.8 32H3.63125V25.6H5.84375C6.47917 25.6 7.025 25.7281 7.48125 25.9844C7.93958 26.2385 8.29167 26.6042 8.5375 27.0812C8.78333 27.5583 8.90625 28.1292 8.90625 28.7937C8.90625 29.4604 8.78229 30.0333 8.53438 30.5125C8.28854 30.9917 7.93333 31.3594 7.46875 31.6156C7.00625 31.8719 6.45 32 5.8 32ZM4.79063 30.9969H5.74375C6.18958 30.9969 6.56146 30.9156 6.85938 30.7531C7.15729 30.5885 7.38125 30.3437 7.53125 30.0187C7.68125 29.6917 7.75625 29.2833 7.75625 28.7937C7.75625 28.3042 7.68125 27.8979 7.53125 27.575C7.38125 27.25 7.15938 27.0073 6.86563 26.8469C6.57396 26.6844 6.21146 26.6031 5.77813 26.6031H4.79063V30.9969ZM15.9026 28.8C15.9026 29.4896 15.7734 30.0802 15.5151 30.5719C15.2588 31.0615 14.9088 31.4365 14.4651 31.6969C14.0234 31.9573 13.5224 32.0875 12.9619 32.0875C12.4015 32.0875 11.8994 31.9573 11.4557 31.6969C11.014 31.4344 10.664 31.0583 10.4057 30.5687C10.1494 30.0771 10.0213 29.4875 10.0213 28.8C10.0213 28.1104 10.1494 27.5208 10.4057 27.0312C10.664 26.5396 11.014 26.1635 11.4557 25.9031C11.8994 25.6427 12.4015 25.5125 12.9619 25.5125C13.5224 25.5125 14.0234 25.6427 14.4651 25.9031C14.9088 26.1635 15.2588 26.5396 15.5151 27.0312C15.7734 27.5208 15.9026 28.1104 15.9026 28.8ZM14.7369 28.8C14.7369 28.3146 14.6609 27.9052 14.5088 27.5719C14.3588 27.2365 14.1505 26.9833 13.8838 26.8125C13.6171 26.6396 13.3099 26.5531 12.9619 26.5531C12.614 26.5531 12.3067 26.6396 12.0401 26.8125C11.7734 26.9833 11.564 27.2365 11.4119 27.5719C11.2619 27.9052 11.1869 28.3146 11.1869 28.8C11.1869 29.2854 11.2619 29.6958 11.4119 30.0312C11.564 30.3646 11.7734 30.6177 12.0401 30.7906C12.3067 30.9615 12.614 31.0469 12.9619 31.0469C13.3099 31.0469 13.6171 30.9615 13.8838 30.7906C14.1505 30.6177 14.3588 30.3646 14.5088 30.0312C14.6609 29.6958 14.7369 29.2854 14.7369 28.8ZM22.6528 27.7594H21.484C21.4507 27.5677 21.3892 27.3979 21.2997 27.25C21.2101 27.1 21.0986 26.9729 20.9653 26.8687C20.8319 26.7646 20.6799 26.6865 20.509 26.6344C20.3403 26.5802 20.158 26.5531 19.9622 26.5531C19.6142 26.5531 19.3059 26.6406 19.0372 26.8156C18.7684 26.9885 18.558 27.2427 18.4059 27.5781C18.2538 27.9115 18.1778 28.3187 18.1778 28.8C18.1778 29.2896 18.2538 29.7021 18.4059 30.0375C18.5601 30.3708 18.7705 30.6229 19.0372 30.7937C19.3059 30.9625 19.6132 31.0469 19.959 31.0469C20.1507 31.0469 20.3299 31.0219 20.4965 30.9719C20.6653 30.9198 20.8163 30.8437 20.9497 30.7437C21.0851 30.6437 21.1986 30.5208 21.2903 30.375C21.384 30.2292 21.4486 30.0625 21.484 29.875L22.6528 29.8812C22.609 30.1854 22.5142 30.4708 22.3684 30.7375C22.2247 31.0042 22.0361 31.2396 21.8028 31.4437C21.5694 31.6458 21.2965 31.8042 20.984 31.9187C20.6715 32.0312 20.3247 32.0875 19.9434 32.0875C19.3809 32.0875 18.8788 31.9573 18.4372 31.6969C17.9955 31.4365 17.6476 31.0604 17.3934 30.5687C17.1392 30.0771 17.0122 29.4875 17.0122 28.8C17.0122 28.1104 17.1403 27.5208 17.3965 27.0312C17.6528 26.5396 18.0017 26.1635 18.4434 25.9031C18.8851 25.6427 19.3851 25.5125 19.9434 25.5125C20.2997 25.5125 20.6309 25.5625 20.9372 25.6625C21.2434 25.7625 21.5163 25.9094 21.7559 26.1031C21.9955 26.2948 22.1924 26.5302 22.3465 26.8094C22.5028 27.0865 22.6049 27.4031 22.6528 27.7594ZM27.3686 27.3594C27.3395 27.0865 27.2165 26.874 26.9999 26.7219C26.7853 26.5698 26.5061 26.4937 26.1624 26.4937C25.9207 26.4937 25.7134 26.5302 25.5405 26.6031C25.3676 26.676 25.2353 26.775 25.1436 26.9C25.052 27.025 25.0051 27.1677 25.003 27.3281C25.003 27.4615 25.0332 27.5771 25.0936 27.675C25.1561 27.7729 25.2405 27.8562 25.3468 27.925C25.453 27.9917 25.5707 28.0479 25.6999 28.0937C25.829 28.1396 25.9593 28.1781 26.0905 28.2094L26.6905 28.3594C26.9322 28.4156 27.1645 28.4917 27.3874 28.5875C27.6124 28.6833 27.8134 28.8042 27.9905 28.95C28.1697 29.0958 28.3113 29.2719 28.4155 29.4781C28.5197 29.6844 28.5718 29.926 28.5718 30.2031C28.5718 30.5781 28.4759 30.9083 28.2843 31.1937C28.0926 31.4771 27.8155 31.699 27.453 31.8594C27.0926 32.0177 26.6561 32.0969 26.1436 32.0969C25.6457 32.0969 25.2134 32.0198 24.8468 31.8656C24.4822 31.7115 24.1968 31.4865 23.9905 31.1906C23.7863 30.8948 23.6759 30.5344 23.6593 30.1094H24.7999C24.8165 30.3323 24.8853 30.5177 25.0061 30.6656C25.127 30.8135 25.2843 30.924 25.478 30.9969C25.6738 31.0698 25.8926 31.1062 26.1343 31.1062C26.3863 31.1062 26.6072 31.0687 26.7968 30.9937C26.9884 30.9167 27.1384 30.8104 27.2468 30.675C27.3551 30.5375 27.4103 30.3771 27.4124 30.1937C27.4103 30.0271 27.3613 29.8896 27.2655 29.7812C27.1697 29.6708 27.0353 29.5792 26.8624 29.5062C26.6915 29.4312 26.4915 29.3646 26.2624 29.3062L25.5343 29.1187C25.0072 28.9833 24.5905 28.7781 24.2843 28.5031C23.9801 28.226 23.828 27.8583 23.828 27.4C23.828 27.0229 23.9301 26.6927 24.1343 26.4094C24.3405 26.126 24.6207 25.9062 24.9749 25.75C25.329 25.5917 25.7301 25.5125 26.178 25.5125C26.6322 25.5125 27.0301 25.5917 27.3718 25.75C27.7155 25.9062 27.9853 26.124 28.1811 26.4031C28.377 26.6802 28.478 26.999 28.4843 27.3594H27.3686Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_522_11102",
    x: 5.39976,
    y: -3.2,
    width: 29.2,
    height: 45.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.894118 0 0 0 0 0.898039 0 0 0 0 0.905882 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_522_11102"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_522_11102",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.813571 0 0 0 0 0.82 0 0 0 0 0.826429 0 0 0 0.32 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_522_11102"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_522_11102",
    x: 0,
    y: 22,
    width: 32,
    height: 17.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_522_11102"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_522_11102"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocIcon);
export default __webpack_public_path__ + "static/media/docIcon.af1789f136a49b13584770799dc554e3.svg";
export { ForwardRef as ReactComponent };